<template>
    <div class="avatar-wrapper">
        <b-skeleton-img
                v-if="showLoadingPlaceholder"
                :width="`${size}rem`"
                :height="`${size}rem`"
                no-aspect
                class="avatar-loading"
        />
        <b-img
                :id="id"
                v-if="src"
                v-show="!imageLoading && !imageError"
                :src="src"
                alt="avatar"
                class="avatar"
                :class="imgCssClass"
                :style="computedImageStyle"
                :lazy="lazy"
                @load="handleLoad"
                @error="handleOnError"
        />
        <div
                :id="id"
                v-if="showText"
                class="avatar"
                :style="[colorStyle, computedImageStyle]"
                :class="[uniqueColorSalt.length ? '' : 'alert-' + color]"
        >
            {{ name | initials(length) }}
        </div>

        <b-tooltip
                v-if="showTooltip"
                :target="id"
                triggers="hover"
        >
            {{ name }}
        </b-tooltip>
    </div>
</template>

<script>
import './Avatar.scss';
import {generateRandomString} from "../../helpers/stringHelpers";
import {colorHelper} from "../../helpers/colorHelper";

const COLORS = [
    'primary',
    'secondary',
    'success',
    'warning',
    'danger',
    'info',
    'dark'
];

export default {
    name: 'Avatar',
    props: {
        src: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        size: {
            type: Number,
            default: 2,
        },
        color: {
            type: String,
            default: 'primary',
            validator: (value) => {
                return COLORS.indexOf(value) !== -1;
            }
        },
        uniqueColorSalt: {
            type: String,
            default: '',
        },
        length: {
            type: Number,
            default: 2,
            validator: (value) => {
                return value >= 1 && value <= 2;
            }
        },
        showTooltip: {
            type: Boolean,
            default: false,
        },
        lazy: {
            type: Boolean,
            default: false,
        },
        imgCssClass: {
            type: String,
            default: '',
        },
    },
    data() {
        let fontSize = this.size * 38 / 100;
        return {
            id: 'avatar-' + generateRandomString(32),
            imageLoading: true,
            imageError: false,
        };
    },

    computed: {
        colorStyle() {
            if (!this.uniqueColorSalt) {
                return {};
            }

            let uniqueColorSaltNumerical = colorHelper.hashCode(this.uniqueColorSalt);
            let backgroundColor = colorHelper.intToRGB(uniqueColorSaltNumerical);
            let backgroundColorRgb = colorHelper.convertHexToRgb(backgroundColor);
            let textColor = colorHelper.niceColor(backgroundColorRgb);

            return {
                backgroundColor: `${backgroundColor}`,
                color: `${textColor}`,
            };
        },
        showText() {
            if (!this.src) {
                return true;
            }
            if (this.imageLoading) {
                return this.imageError;
            }
            return false;
        },
        showLoadingPlaceholder() {
            if (!this.src) {
                return false;
            }
            return this.imageLoading && !this.imageError;
        },
        computedImageStyle() {
            return {
                width: `${this.size}rem`,
                height: `${this.size}rem`,
                lineHeight: `${this.size}rem`,
                fontSize: `${this.fontSize}rem`,
            };
        }
    },
    methods: {
        handleOnError() {
            this.imageError = true;
        },
        handleLoad() {
            this.imageLoading = false;
        },
    }
};
</script>
